export default __webpack_public_path__ + "static/media/gsg-logo.0cfdc747.svg";